import Product from './Product';
import { reRunScripts } from '../../helpers';

const selectors = {
  swatchProductUrl: '[data-swatch-product-url]',
  product: '[data-product]',
  syncSection: '[data-product-sync]',
};

/**
 * Async product switching functionality
 *
 * @export
 * @class ProductAsyncSwitcher
 */
export default class ProductAsyncSwitcher {
  constructor(el, sectionId) {
    this.el = el;
    this.sectionId = sectionId;

    const swatchProductUrls = el.querySelectorAll(selectors.swatchProductUrl);
    swatchProductUrls.forEach(link => {
      const handle = link.dataset.swatchProductUrl;
      if (handle) {
        link.addEventListener('click', e => {
          e.preventDefault();
          this._updateURL(handle);
          this._fetchProductByHandle(handle);
          const syncSections = document.querySelectorAll(selectors.syncSection);
          syncSections.forEach(section => {
            const syncSectionId = section.dataset.sectionId;
            if (syncSectionId) {
              this._fetchSectionByHandle(section, handle, syncSectionId);
            }
          });
        });
      }
    });
  }

  _fetchProductByHandle(handle) {
    fetch(
      `${window.Shopify.routes.root}products/${handle}?section_id=${this.sectionId}`,
    )
      .then(response => response.text())
      .then(responseText => {
        const html = responseText;
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
        const newRoot = parsedHTML.querySelector(selectors.product);
        const variantInventory = newRoot.dataset.variantInventory;
        this.el.dataset.variantInventory = variantInventory;
        this.el.innerHTML = newRoot.innerHTML;
        new Product(this.el, {}, this.sectionId);
      });
  }

  _fetchSectionByHandle(el, handle, sectionId) {
    fetch(
      `${window.Shopify.routes.root}products/${handle}?section_id=${sectionId}`,
    )
      .then(response => response.text())
      .then(responseText => {
        const html = responseText;
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
        const newRoot = parsedHTML.querySelector(selectors.syncSection);
        el.innerHTML = newRoot.innerHTML;
        reRunScripts(el);
      });
  }

  _updateURL(handle) {
    const url = `${window.Shopify.routes.root}products/${handle}`;
    history.replaceState({}, '', url);
  }
}
